import React from 'react';
import { getJsonDate, getMonthYearString } from './JsonFunctions.js';
import { getTranslation } from './GetTranslation.js';

export const getObjectiveFunctionsFormList = (objectiveFunctions) => {
    let functionValues = objectiveFunctions;
    for (var iFun = 0; iFun < functionValues.length; iFun++) {
        functionValues[iFun].text = functionValues[iFun].functionText;
    }
    return functionValues;
}

export const getObjectiveSectorsFormList = (objectiveSectors) => {
    let sectorValues = objectiveSectors;
    for (var iSec = 0; iSec < sectorValues.length; iSec++) {
        sectorValues[iSec].text = sectorValues[iSec].sectorText;
    }  
    return sectorValues;
}

export const getPersonRegionsFormList = (personRegions) => {
    let regionValues = personRegions;
    for (var i = 0; i< regionValues.length; i++) {
        regionValues[i].text = regionValues[i].regionText;
    }  
    return regionValues;
}

export const getWorkExperiencesFormList = (personWorkExperiences) => {
    var workExperiences = [];

    for (var i = 0; i < personWorkExperiences.length; i++) {
        var workExperience = personWorkExperiences[i];
        var item = {
            id: workExperience.id,
            text: 
                <div>
                    <span>{getMonthYearString(getJsonDate(workExperience.datStart)) + " - " 
                        + (getMonthYearString(getJsonDate(workExperience.datLeave)) || getTranslation("sns.webparts.workexperiences.untilnow"))}</span>:&nbsp;
                    <strong>{workExperience.function}</strong>                            
                    <br/>{workExperience.org + " " + (workExperience.orgAddress || "")}
                </div> 
        };
        workExperiences.push(item);
    }

    return workExperiences;
}

export const getEducationsFormList = (personEducations) => {
    var educations = [];

    for (var iEdu = 0; iEdu < personEducations.length; iEdu++) {
        var education = personEducations[iEdu];
        var item = {
            id: education.id,
            text: 
                <div>
                    <span>{education.yearGrad}</span>:&nbsp; 
                    <strong>{education.description}</strong>                            
                    <br/>{education.org}
                </div> 
        };
        educations.push(item);
    }

    return educations;
}

export const registerIndeed = () => {
    const script = document.createElement("script");

    script.src = "//conv.indeed.com/applyconversion.js";
    script.async = true;

    document.body.appendChild(script);
}


// WEBPACK FOOTER //
// ./src/Utilities/SnsFunctions.js